module.exports = __webpack_public_path__ + "static/media/help.0021e6ad.svg";